import { Button } from "antd";
import styled from "styled-components";
import { color } from "../../res/color";

export const ButtonPrimary = styled(Button)<any>`
  border-radius: 8px;
  background: ${color.THEME};
  border-color: ${color.THEME};
  width: ${(p) => (p.width ? p.width : "100%")} !important;

  height: 32px;
  color: ${color.WHITE};
  &:hover {
    opacity: 0.8;
    background: ${color.THEME};
    border-color: ${color.LIGHTBLUE};
    color: ${color.LIGHTBLUE};
  }
  &:focus {
    background: ${color.THEME};
    color: ${color.LIGHTBLUE};
    opacity: 0.8;
  }
`;

export const ButtonDefault = styled(Button)<any>`
  border-radius: 8px;
  color: ${color.WHITE};
  background: ${color.WARNING};
  border-color: ${color.WARNING};
  width: ${(p) => (p.width ? p.width : "100%")} !important;
  height: 32px;

  &:hover {
    opacity: 0.8;
    background: #ffd747ff !important;
    border-color: ${color.NOPTCOLOR} !important;
    color: ${color.WHITE}!important;
  }
  &:focus {
    background: ${color.WARNING} !important;
    color: ${color.WHITE} !important;
    opacity: 0.8;
  }
`;
